import Cookies from "js-cookie";
import ConsentedCookie from '../../../../scripts/classes/ConsentedCookie';

var GlobalAlertComponent = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

GlobalAlertComponent.prototype.init = function(){

  var self = this;

  var height = this.options.$el.height();
  var cookieToSet = this.options.$el.data('global-alert-cookie');
  var cookieValue = this.options.$el[0].dataset.globalAlertCookieValue;
  
  document.body.style.setProperty('--global-alert-height', height + 'px');
  this.options.$el[0].style.setProperty('--global-alert-position', 'fixed');

  this.options.$el.find("[data-global-alert-close]").on("click", function(){
    // set height to 0
    self.options.$el.height(0);
    document.body.style.setProperty('--global-alert-height', '0px');
    self.options.$el.hide();

    // set cookie
    ConsentedCookie.set(cookieToSet, cookieValue, 'functional', { expires: 30 });
    
  });



};

export default  GlobalAlertComponent;